import Login from "../views/login/login.vue";
import Welcome from "../views/home/welcome.vue";
import Home from "../views/home/home.vue";
import refresh from "../views/home/refresh.vue";
import MENU from "./menu";


let baseTypes = '/'
if (window.__POWERED_BY_QIANKUN__) {
  baseTypes = '/power'
}
const childrenRoutes = [
  {
    path: "/refresh",
    name:'refresh',
    component: refresh
  },
  {
    path: "/welcome",
    component: Welcome
  }
];

const eachStandardData = (nodes, callback, pId, index) => {
  if ((typeof callback) === 'function') {
    let newPId = val => {
      if(!val) return '1';
      let arr = val.split('-');
      arr.push((index + 1) + '');
      return arr.join('-');
    }

    if (Array.isArray(nodes) && nodes.length > 0) {
      let id = newPId(pId);

      nodes.forEach((node, index) => {
        eachStandardData(node, callback, id, index);
      });

      return;
    }

    if ((typeof nodes) === 'object') {
      let id = newPId(pId);
      let flag = callback(id, nodes);

      if (Array.isArray(nodes.subMenus) && nodes.subMenus.length > 0 && flag) {
        nodes.subMenus.forEach((child, index) => {
          eachStandardData(child, callback, id, index);
        });
      }
    }
  }
}

// menuTreeMetaData 就是需要渲染的菜单数据
let menuTreeMetaData = MENU;
let menuMap = new Map(); // 保存 id -> menuNode，点击按钮方便查询菜单节点信息。

eachStandardData(menuTreeMetaData, (id, node) => {
  node.id = id;
  menuMap.set(id, node);
  return true;
});


function loopMenu(menus,parentId,parentArr){
  for (const menu of menus){
    if(menu.subMenus){
      loopMenu(menu.subMenus)
    } else {
      childrenRoutes.push(menu);
    }
  }
}

loopMenu(menuTreeMetaData)

// childrenRoutes.push({
//   path: "*",
//   redirect: "/welcome"
// });

let childrenRoutesMap = childrenRoutes.map(item => {
  if(item.id){
    item.meta.id = item.id
    return item
  }else {
    return item
  }
})

const routes = [
  {
    path: "/login",
    name:'login',
    component: Login
  },
  {
    path: "/home",
    name:'home',
    component: Home
  },
  ...childrenRoutesMap
];
function loopPath(data) {
  for (var i = 0; i < data.length; i++) {
    data[i].path = baseTypes + data[i].path
    console.log(data[i].path)
    if (data[i].children && data[i].children.length > 0) {
      loopPath(data[i].children)
    }
  }
}
if (baseTypes !== '/') {
  loopPath(routes)
}
console.log(routes, '==================================')
console.log(window.history.state)
export default routes;
